
import { Component } from "vue-property-decorator";
import { Vue } from "vue-property-decorator";
import Spinner from "@/components/views/Spinner.vue"

@Component({
    components: {
      Spinner
    }
})
export default class Home extends Vue {
  isImageLoaded = false;

  created() {
      //console.log("Home page has been created.")
  }

  onImgLoad() {
        this.isImageLoaded = true;
    }


  onPuzzleClick() {
      this.$router.push( "/demo");
  }
}
